import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-dashboard-annoncement',
    templateUrl: './dashboard-annoncement.component.html',
    styleUrls: ['./dashboard-annoncement.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardAnnoncementComponent {

}
